(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.currentState = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.score = 0;
        this.isIdle = true;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft(gameBoard) {
                var _this = this;
                if (this.getStatus() !== "playing") return;
                var addedTiles = [];
                var isChanged = false;
                for(var i = 1; i < 4; i++){
                    var _this1 = this, _loop = function(j) {
                        var _this2 = _this1, _loop = function(k) {
                            if (_this2.currentState[j][k - 1] === 0 && _this2.currentState[j][k] !== 0) {
                                isChanged = true;
                                if (addedTiles.some(function(tile) {
                                    return tile[0] === j && tile[1] === k && tile[2] === _this.currentState[j][k];
                                })) {
                                    addedTiles.push([
                                        j,
                                        k - 1,
                                        _this2.currentState[j][k]
                                    ]);
                                    addedTiles.filter(function(tile) {
                                        return tile[0] !== j && tile[1] !== k;
                                    });
                                }
                                _this2.currentState[j][k - 1] = _this2.currentState[j][k];
                                _this2.currentState[j][k] = 0;
                            } else if (_this2.currentState[j][k - 1] === _this2.currentState[j][k] && _this2.currentState[j][k] !== 0) {
                                isChanged = true;
                                if (!addedTiles.some(function(tile) {
                                    return tile[0] === j && tile[1] === k && tile[2] === _this.currentState[j][k];
                                }) && !addedTiles.some(function(tile) {
                                    return tile[0] === j && tile[1] === k - 1 && tile[2] === _this.currentState[j][k - 1];
                                })) {
                                    var result = _this2.currentState[j][k] * 2;
                                    _this2.score += result;
                                    _this2.currentState[j][k - 1] = result;
                                    _this2.currentState[j][k] = 0;
                                    addedTiles.push([
                                        j,
                                        k - 1,
                                        result
                                    ]);
                                }
                            }
                        };
                        for(var k = 1; k < 4; k++)_loop(k);
                    };
                    for(var j = 0; j < 4; j++)_loop(j);
                }
                if (isChanged) {
                    isChanged = false;
                    this.addRandomTile();
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                if (this.getStatus() !== "playing") return;
                var addedTiles = [];
                var isChanged = false;
                for(var i = 1; i < 4; i++){
                    var _this1 = this, _loop = function(j) {
                        var _this2 = _this1, _loop = function(k) {
                            if (_this2.currentState[j][k + 1] === 0 && _this2.currentState[j][k] !== 0) {
                                isChanged = true;
                                if (addedTiles.some(function(tile) {
                                    return tile[0] === j && tile[1] === k && tile[2] === _this.currentState[j][k];
                                })) {
                                    addedTiles.push([
                                        j,
                                        k + 1,
                                        _this2.currentState[j][k]
                                    ]);
                                    addedTiles.filter(function(tile) {
                                        return tile[0] !== j && tile[1] !== k;
                                    });
                                }
                                _this2.currentState[j][k + 1] = _this2.currentState[j][k];
                                _this2.currentState[j][k] = 0;
                            } else if (_this2.currentState[j][k + 1] === _this2.currentState[j][k] && _this2.currentState[j][k] !== 0) {
                                isChanged = true;
                                if (!addedTiles.some(function(tile) {
                                    return tile[0] === j && tile[1] === k && tile[2] === _this.currentState[j][k];
                                }) && !addedTiles.some(function(tile) {
                                    return tile[0] === j && tile[1] === k + 1 && tile[2] === _this.currentState[j][k + 1];
                                })) {
                                    var result = _this2.currentState[j][k] * 2;
                                    _this2.score += result;
                                    _this2.currentState[j][k + 1] = result;
                                    _this2.currentState[j][k] = 0;
                                    addedTiles.push([
                                        j,
                                        k + 1,
                                        result
                                    ]);
                                }
                            }
                        };
                        for(var k = 2; k >= 0; k--)_loop(k);
                    };
                    for(var j = 0; j < 4; j++)_loop(j);
                }
                if (isChanged) {
                    isChanged = false;
                    this.addRandomTile();
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                if (this.getStatus() !== "playing") return;
                var addedTiles = [];
                var isChanged = false;
                for(var i = 1; i < 4; i++){
                    var _this1 = this, _loop = function(j) {
                        var _this2 = _this1, _loop = function(k) {
                            if (_this2.currentState[k - 1][j] === 0 && _this2.currentState[k][j] !== 0) {
                                isChanged = true;
                                if (addedTiles.some(function(tile) {
                                    return tile[0] === k && tile[1] === j && tile[2] === _this.currentState[k][j];
                                })) {
                                    addedTiles.push([
                                        k - 1,
                                        j,
                                        _this2.currentState[k][j]
                                    ]);
                                    addedTiles.filter(function(tile) {
                                        return tile[0] !== k && tile[1] !== j;
                                    });
                                }
                                _this2.currentState[k - 1][j] = _this2.currentState[k][j];
                                _this2.currentState[k][j] = 0;
                            } else if (_this2.currentState[k - 1][j] === _this2.currentState[k][j] && _this2.currentState[k][j] !== 0) {
                                isChanged = true;
                                if (!addedTiles.some(function(tile) {
                                    return tile[0] === k && tile[1] === j && tile[2] === _this.currentState[k][j];
                                }) && !addedTiles.some(function(tile) {
                                    return tile[0] === k - 1 && tile[1] === j && tile[2] === _this.currentState[k - 1][j];
                                })) {
                                    var result = _this2.currentState[k][j] * 2;
                                    _this2.score += result;
                                    _this2.currentState[k - 1][j] = result;
                                    _this2.currentState[k][j] = 0;
                                    addedTiles.push([
                                        k - 1,
                                        j,
                                        result
                                    ]);
                                }
                            }
                        };
                        for(var k = 1; k < 4; k++)_loop(k);
                    };
                    for(var j = 0; j < 4; j++)_loop(j);
                }
                if (isChanged) {
                    isChanged = false;
                    this.addRandomTile();
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                if (this.getStatus() !== "playing") return;
                var addedTiles = [];
                var isChanged = false;
                for(var i = 1; i < 4; i++){
                    var _this1 = this, _loop = function(j) {
                        var _this2 = _this1, _loop = function(k) {
                            if (_this2.currentState[k + 1][j] === 0 && _this2.currentState[k][j] !== 0) {
                                isChanged = true;
                                if (addedTiles.some(function(tile) {
                                    return tile[0] === k && tile[1] === j && tile[2] === _this.currentState[k][j];
                                })) {
                                    addedTiles.push([
                                        k + 1,
                                        j,
                                        _this2.currentState[k][j]
                                    ]);
                                    addedTiles.filter(function(tile) {
                                        return tile[0] !== k && tile[1] !== j;
                                    });
                                }
                                _this2.currentState[k + 1][j] = _this2.currentState[k][j];
                                _this2.currentState[k][j] = 0;
                            } else if (_this2.currentState[k + 1][j] === _this2.currentState[k][j] && _this2.currentState[k][j] !== 0) {
                                isChanged = true;
                                if (!addedTiles.some(function(tile) {
                                    return tile[0] === k && tile[1] === j && tile[2] === _this.currentState[k][j];
                                }) && !addedTiles.some(function(tile) {
                                    return tile[0] === k + 1 && tile[1] === j && tile[2] === _this.currentState[k + 1][j];
                                })) {
                                    var result = _this2.currentState[k][j] * 2;
                                    _this2.score += result;
                                    _this2.currentState[k + 1][j] = result;
                                    _this2.currentState[k][j] = 0;
                                    addedTiles.push([
                                        k + 1,
                                        j,
                                        result
                                    ]);
                                }
                            }
                        };
                        for(var k = 2; k >= 0; k--)_loop(k);
                    };
                    for(var j = 0; j < 4; j++)_loop(j);
                }
                if (isChanged) {
                    isChanged = false;
                    this.addRandomTile();
                }
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.currentState;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                if (this.isIdle) {
                    this.status = "idle";
                    return this.status;
                }
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.currentState[i][j] === 2048) {
                        this.status = "win";
                        return this.status;
                    }
                }
                for(var i1 = 0; i1 < 4; i1++)for(var j1 = 0; j1 < 4; j1++){
                    var current = this.currentState[i1][j1];
                    if (current === 0 || i1 > 0 && current === this.currentState[i1 - 1][j1] || i1 < 3 && current === this.currentState[i1 + 1][j1] || j1 > 0 && current === this.currentState[i1][j1 - 1] || j1 < 3 && current === this.currentState[i1][j1 + 1]) {
                        this.status = "playing";
                        return this.status;
                    }
                }
                this.status = "lose";
                return this.status;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                while(true){
                    var row = Math.round(Math.random() * 3);
                    var cell = Math.round(Math.random() * 3);
                    if (this.currentState[row][cell] === 0) {
                        this.currentState[row][cell] = Math.random() * 10 > 1 ? 2 : 4;
                        return;
                    }
                }
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.isIdle = false;
                this.score = 0;
                for(var i = 0; i < 2; i++)this.addRandomTile();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.isIdle = true;
                this.status = "idle";
                this.currentState = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.score = 0;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector(".button, .start");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
var $197cd56b15c33885$var$hint = $197cd56b15c33885$var$startMessage.nextElementSibling;
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$gameBoard = document.querySelector("tbody");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
function $197cd56b15c33885$var$printBoard() {
    for(var i = 0; i < $197cd56b15c33885$var$gameBoard.rows.length; i++)for(var j = 0; j < $197cd56b15c33885$var$gameBoard.rows[i].cells.length; j++){
        var cell = $197cd56b15c33885$var$gameBoard.rows[i].cells[j];
        var cellValue = $197cd56b15c33885$var$game.currentState[i][j];
        if ($197cd56b15c33885$var$game.currentState[i][j] !== 0) {
            cell.textContent = cellValue;
            cell.className = "field-cell";
            cell.classList.add("field-cell--".concat(cellValue));
        } else {
            cell.textContent = "";
            cell.className = "field-cell";
        }
    }
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.isIdle = false;
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startMessage.classList.add("hidden");
        $197cd56b15c33885$var$hint.classList.remove("hidden");
        $197cd56b15c33885$var$winMessage.classList.add("hidden");
        $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    } else {
        $197cd56b15c33885$var$game.isIdle = true;
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$startButton.textContent = "Start";
        $197cd56b15c33885$var$startButton.classList.remove("restart");
        $197cd56b15c33885$var$startButton.classList.add("start");
        $197cd56b15c33885$var$startMessage.classList.remove("hidden");
        $197cd56b15c33885$var$hint.classList.add("hidden");
        $197cd56b15c33885$var$winMessage.classList.add("hidden");
        $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    }
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$printBoard();
});
document.addEventListener("keydown", function(e) {
    var key = e.key;
    switch(key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            break;
    }
    if (key === "ArrowLeft" || key === "ArrowRight" || key === "ArrowUp" || key === "ArrowDown") $197cd56b15c33885$var$printBoard();
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "win") {
        $197cd56b15c33885$var$hint.classList.add("hidden");
        $197cd56b15c33885$var$winMessage.classList.remove("hidden");
    } else if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        $197cd56b15c33885$var$hint.classList.add("hidden");
        $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
    }
});
var $197cd56b15c33885$var$touchStartX = 0;
var $197cd56b15c33885$var$touchStartY = 0;
document.addEventListener("touchstart", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") return;
    $197cd56b15c33885$var$touchStartX = e.touches[0].clientX;
    $197cd56b15c33885$var$touchStartY = e.touches[0].clientY;
});
document.addEventListener("touchmove", function(e) {
    // Перевіряємо, чи це свайп вниз
    if (e.touches && e.touches.length === 1) // Можна додати додаткову перевірку напрямку свайпу, якщо потрібно
    e.preventDefault();
}, {
    passive: false
});
document.addEventListener("touchend", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") return;
    var touchEndX = e.changedTouches[0].clientX;
    var touchEndY = e.changedTouches[0].clientY;
    var dx = touchEndX - $197cd56b15c33885$var$touchStartX;
    var dy = touchEndY - $197cd56b15c33885$var$touchStartY;
    if (Math.abs(dx) > Math.abs(dy)) {
        if (dx >= 50) $197cd56b15c33885$var$game.moveRight();
        else if (dx <= -50) $197cd56b15c33885$var$game.moveLeft();
    } else {
        if (dy <= -50) $197cd56b15c33885$var$game.moveUp();
        else if (dy >= 50) $197cd56b15c33885$var$game.moveDown();
    }
    $197cd56b15c33885$var$printBoard();
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "win") {
        $197cd56b15c33885$var$hint.classList.add("hidden");
        $197cd56b15c33885$var$winMessage.classList.remove("hidden");
    } else if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        $197cd56b15c33885$var$hint.classList.add("hidden");
        $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
    }
});

})();
//# sourceMappingURL=index.134cca3b.js.map
